import {Component} from "@angular/core";

@Component({
  selector: 'micro-sm-charts',
  templateUrl: './sm-charts.component.html'
})
export class SmChartsComponent {

}
